// main.js.liquid

import * as THREE from "three";
import { gsap } from "gsap";

// Импорт базовых модулей сцены и элементов
import {
  scene,
  camera,
  renderer,
  clock,
  initialCameraPosition,
} from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/scene.js?v=40729775892401091901739451402';

import { createRoom } from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/room.js?v=29083942139661579861739019319';
import { createTextPanel } from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/text-panels.js?v=14322335696060096591738885795';
import { createNavigationButton } from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/nav-buttons.js?v=101312183587642835701744301156';

import {
  frameGroup,
  hexGroup,
  movingHexes,
  planeMesh,
  ringMesh,
  rebuildFrameAndHexes,
} from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/frame-hex.js?v=6951859043841207041739472775';

import { loadImageIntoFrame } from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/image-loader.js?v=104947866816733988271739472785';
import PurchaseButton from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/purchase-button.js?v=30434682027442248451739586905';

// Импорт новых 3D-модулей
import ProductTitle from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/product-title.js?v=120115073118102905051739198986';
import FullscreenButton from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/fullscreen-button.js?v=141595168898328879201739115873';
import SocialLinks from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/social-links.js?v=56901509682117041461744293425';

// === Импортируем нужные функции из svg-timer.js (без init3DCountdownTimers)
import {
  createSVGTimer,
  setTimerValue,
  parseAvailabilityDate
} from '//www.hecticdecals.com.au/cdn/shop/t/4/assets/svg-timer.js?v=3112628717953210901739223844';

// --------------------------------------------------------------------------------------
// Объявляем переменную socialLinks ЗАРАНЕЕ, чтобы она была видна в animate()
// --------------------------------------------------------------------------------------
let socialLinks;

// --------------------------------------------------------------------------------------
// 1) Создаем комнату и добавляем "комнатные" элементы в сцену
// --------------------------------------------------------------------------------------
createRoom(scene);

// --------------------------------------------------------------------------------------
// 2) Создаем текстовые панели (левая и правая) и добавляем их в сцену
// --------------------------------------------------------------------------------------
const leftPanel = createTextPanel("Левый текст", new THREE.Vector3(2, 0, 20));
const rightPanel = createTextPanel("Правый текст", new THREE.Vector3(2, 0, -2));
scene.add(leftPanel);
scene.add(rightPanel);

// --------------------------------------------------------------------------------------
// 3) Создаем группу навигационных кнопок и сами кнопки
// --------------------------------------------------------------------------------------
const navButtonsGroup = new THREE.Group();
navButtonsGroup.position.set(2, -0.75, 0);
navButtonsGroup.rotation.y = Math.PI / 2;

const productDescription = window.product && window.product.description
  ? window.product.description
  : "";

const buttonNavRight = createNavigationButton({
  productDescription: productDescription,
});
buttonNavRight.userData.screenId = "navRight";
// Временно включённый hover для примера
buttonNavRight.userData.updateHover(true);

const buttonNavLeft = createNavigationButton({
  position: new THREE.Vector3(-0.7, -0.3, 0),
  productDescription: productDescription,
});
buttonNavLeft.userData.screenId = "navLeft";

navButtonsGroup.add(buttonNavRight, buttonNavLeft);
scene.add(navButtonsGroup);

// 4) Создаем Raycaster-ы для навигационных кнопок и текстовых панелей
const navRaycaster = new THREE.Raycaster();
const textPanelRaycaster = new THREE.Raycaster();
let hoveredTextPanel = null;
let activeNavButton = null;

// --------------------------------------------------------------------------------------
// 5) Добавляем рамку и "соты" в сцену
// --------------------------------------------------------------------------------------
scene.add(frameGroup);
scene.add(hexGroup);

// Явно вызываем rebuildFrameAndHexes, чтобы заполнить hexGroup
console.log("Вызываем rebuildFrameAndHexes для генерации гексов...");
rebuildFrameAndHexes(
  2.0,   // outerW
  1.0,   // outerH
  1.8,   // innerW
  0.8,   // innerH
  null,  // texture (null, если нет кастомной текстуры)
  0.074, // hexRadius
  0.1    // hexThickness
);

// --------------------------------------------------------------------------------------
// 6) Загружаем изображение в рамке (с небольшой задержкой)
// --------------------------------------------------------------------------------------

// Функция для извлечения текста между тегами (например, <imglink>...</imglink>)
function extractTagText(text, tagName) {
  if (typeof text !== "string") return null;
  // Ищем <tagName>...</tagName> без учета регистра
  const regex = new RegExp(`<${tagName}>([\\s\\S]*?)</${tagName}>`, 'i');
  const match = text.match(regex);
  return match ? match[1].trim() : null;
}

setTimeout(() => {
  // Если в описании продукта есть тег <imglink>, используем его содержимое как URL изображения,
  // иначе — используем значение глобальной переменной window.colorImageUrl
  const customImageUrl = extractTagText(productDescription, "imglink");
  if (customImageUrl) {
    loadImageIntoFrame(customImageUrl);
    console.log("Загружаем изображение из <imglink> тега:", customImageUrl);
  } else {
    loadImageIntoFrame(window.colorImageUrl);
    console.log("Загружаем изображение из window.colorImageUrl:", window.colorImageUrl);
  }
}, 0.001);

console.log("window.currentVariant =", window.currentVariant);
const formattedPrice = '$' + (window.currentVariant.price / 100).toFixed(2);
const purchaseButton = new PurchaseButton(camera, {
  basePosition: new THREE.Vector3(2, -0.75, 0),
  variantId: window.currentVariant.id,
  price: formattedPrice,
});
scene.add(purchaseButton.object3D);

// --------------------------------------------------------------------------------------
// 8) Создаем новые 3D‑элементы (продуктовое название, кнопка FS, соцссылки)
// --------------------------------------------------------------------------------------
const productTitle = new ProductTitle(camera, {
  text: window.product && window.product.title ? window.product.title : 'Product Name',
  basePosition: new THREE.Vector3(1.65, 1.35, 0),
  radius: 0.2,
  thickness: 0.1,
  hoverScale: 1,
  animationSpeed: 0.1,
});
scene.add(productTitle.object3D);

const fullscreenButton = new FullscreenButton(camera, {
  basePosition: new THREE.Vector3(2, -1.25, 0),
  text: 'Fullscreen',
  radius: 0.2,
  thickness: 0.1,
  hoverScale: 1,
  animationSpeed: 0.1,
});
scene.add(fullscreenButton.object3D);

const defaultInnerH = 2.5;
const initialInnerH = (frameGroup.userData && typeof frameGroup.userData.innerH === 'number')
  ? frameGroup.userData.innerH
  : defaultInnerH;

// Создаём соцссылки (примерно у нижней кромки рамки)
{
  const basePosition = new THREE.Vector3(0, -initialInnerH / 2, 0);
  const offsetDistance = 0.1;
  const localNormal = new THREE.Vector3(0, 1, 0);
  localNormal.applyQuaternion(frameGroup.quaternion);
  const extrudedPosition = new THREE.Vector3().copy(basePosition).add(localNormal.multiplyScalar(offsetDistance));

  socialLinks = new SocialLinks(camera, productDescription, {
    basePosition: extrudedPosition,
    buttonRadius: 0.06,
    buttonThickness: 0.05,
    spacing: 0.3,
    hoverScale: 1,
    animationSpeed: 0.1,
  });
  frameGroup.add(socialLinks.object3D);
}

// --------------------------------------------------------------------------------------
// 9) Настраиваем отслеживание курсора относительно канваса
// --------------------------------------------------------------------------------------
const cursor = new THREE.Vector2(0, 0);
renderer.domElement.addEventListener("mousemove", (event) => {
  const rect = renderer.domElement.getBoundingClientRect();
  cursor.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
  cursor.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
});

// --------------------------------------------------------------------------------------
// 10) Определяем параметры для навигации и зума рамки
// --------------------------------------------------------------------------------------
const isVertical = window.innerWidth < window.innerHeight;
const navCameraTargetsVertical = {
  navLeft: {
    position: new THREE.Vector3(8, 0.5, 2),
    lookAt: new THREE.Vector3(0, 0, 2),
    duration: 1.5,
  },
  navRight: {
    position: new THREE.Vector3(8, 0.5, -2),
    lookAt: new THREE.Vector3(0, 0, -2),
    duration: 1.5,
  },
};
const navCameraTargetsHorizontal = {
  navLeft: {
    position: new THREE.Vector3(6, 0.5, 1.5),
    lookAt: new THREE.Vector3(0, 0, 0),
    duration: 1.5,
  },
  navRight: {
    position: new THREE.Vector3(6, 0.5, -1.5),
    lookAt: new THREE.Vector3(0, 0, 0),
    duration: 1.5,
  },
};
const navCameraTargets = isVertical
  ? navCameraTargetsVertical
  : navCameraTargetsHorizontal;

const frameCameraTargetsVertical = { closeDistance: 3, duration: 1.0 };
const frameCameraTargetsHorizontal = { closeDistance: 1, duration: 1.0 };
const frameCameraTargets = isVertical
  ? frameCameraTargetsVertical
  : frameCameraTargetsHorizontal;

const targetCameraPosition = new THREE.Vector3().copy(initialCameraPosition);
const initialLookAt = new THREE.Vector3(0, 0, 0);
const targetLookAt = new THREE.Vector3().copy(initialLookAt);

let isCameraClose = false;
let closeCameraPosition = new THREE.Vector3();

// --------------------------------------------------------------------------------------
// 11) Обработчик клика по сцене (навигационные кнопки, рамка и т.д.)
// --------------------------------------------------------------------------------------
function handleClick(event) {
  const rect = renderer.domElement.getBoundingClientRect();
  const offsetX = event.clientX - rect.left;
  const offsetY = event.clientY - rect.top;
  cursor.x = (offsetX / rect.width) * 2 - 1;
  cursor.y = -(offsetY / rect.height) * 2 + 1;

  // 1) Навигационные кнопки
  navRaycaster.setFromCamera(cursor, camera);
  const navIntersections = navRaycaster.intersectObjects(navButtonsGroup.children, true);
  if (navIntersections.length > 0) {
    let clickedObj = navIntersections[0].object;
    while (clickedObj && (typeof clickedObj.userData.toggleClickAnimation !== "function")) {
      clickedObj = clickedObj.parent;
    }
    if (clickedObj && typeof clickedObj.userData.toggleClickAnimation === "function") {
      const id = clickedObj.userData.screenId;
      if (id) {
        if (activeNavButton === clickedObj) {
          gsap.to(targetCameraPosition, {
            duration: navCameraTargets[id].duration,
            x: initialCameraPosition.x,
            y: initialCameraPosition.y,
            z: initialCameraPosition.z,
            ease: "power2.inOut",
          });
          gsap.to(targetLookAt, {
            duration: navCameraTargets[id].duration,
            x: initialLookAt.x,
            y: initialLookAt.y,
            z: initialLookAt.z,
            ease: "power2.inOut",
          });
          activeNavButton = null;
        } else {
          if (navCameraTargets[id]) {
            const targetPos = navCameraTargets[id].position;
            const targetView = navCameraTargets[id].lookAt;
            const duration = navCameraTargets[id].duration;
            gsap.to(targetCameraPosition, {
              duration: duration,
              x: targetPos.x,
              y: targetPos.y,
              z: targetPos.z,
              ease: "power2.inOut",
            });
            gsap.to(targetLookAt, {
              duration: duration,
              x: targetView.x,
              y: targetView.y,
              z: targetView.z,
              ease: "power2.inOut",
            });
            activeNavButton = clickedObj;
          }
        }
      }
      clickedObj.userData.toggleClickAnimation();
      return;
    }
  }

  // 2) Рамка / изображение (zoom)
  const imageRaycaster = new THREE.Raycaster();
  imageRaycaster.setFromCamera(cursor, camera);
  const imageIntersections = planeMesh ? imageRaycaster.intersectObject(planeMesh, true) : [];
  const imageHovered = imageIntersections.length > 0;
  if (imageHovered) {
    isCameraClose = !isCameraClose;
    let imageCenter = new THREE.Vector3();
    planeMesh.getWorldPosition(imageCenter);
    let direction = new THREE.Vector3().subVectors(camera.position, imageCenter).normalize();
    const CLOSE_DISTANCE = frameCameraTargets.closeDistance;
    const duration = frameCameraTargets.duration;
    if (isCameraClose) {
      closeCameraPosition.copy(imageCenter).add(direction.multiplyScalar(CLOSE_DISTANCE));
      gsap.to(targetCameraPosition, {
        duration: duration,
        x: closeCameraPosition.x,
        y: closeCameraPosition.y,
        z: closeCameraPosition.z,
        ease: "power2.inOut",
      });
      gsap.to(targetLookAt, {
        duration: duration,
        x: imageCenter.x,
        y: imageCenter.y,
        z: imageCenter.z,
        ease: "power2.inOut",
      });
    } else {
      gsap.to(targetCameraPosition, {
        duration: duration,
        x: initialCameraPosition.x,
        y: initialCameraPosition.y,
        z: initialCameraPosition.z,
        ease: "power2.inOut",
      });
      gsap.to(targetLookAt, {
        duration: duration,
        x: initialLookAt.x,
        y: initialLookAt.y,
        z: initialLookAt.z,
        ease: "power2.inOut",
      });
    }
    activeNavButton = null;
  }
}
renderer.domElement.addEventListener("click", handleClick);

// --------------------------------------------------------------------------------------
// Объекты для анимаций стеклянных цилиндров (если в сцене есть)
// --------------------------------------------------------------------------------------
const glassCylinderGroups = [];
scene.traverse((obj) => {
  if (typeof obj.updateBubbles === "function" && typeof obj.updateFlicker === "function") {
    glassCylinderGroups.push(obj);
  }
});

// --------------------------------------------------------------------------------------
// 12) Создаём 3D‑таймер через тег товара "countdown:YYYY/M/D-HH:MMAM/PM"
//     и "привязываем" его к верхней кромке рамки
// --------------------------------------------------------------------------------------
let countdownTag = null;
if (window.product && Array.isArray(window.product.tags)) {
  // Ищем тег, начинающийся с "countdown:"
  countdownTag = window.product.tags.find(tag => tag.startsWith("countdown:"));
}

if (countdownTag) {
  // Вырезаем часть после "countdown:"
  const dateStr = countdownTag.replace("countdown:", "").trim();
  const endDate = parseAvailabilityDate(dateStr);

  if (endDate) {
    // 1) Создаём пустую 3D-группу под таймер
    const myTimerGroup = new THREE.Group();

    // Добавляем группу не в сцену, а в рамку (frameGroup),
    // чтобы таймер «ехал» вместе с рамкой.
    frameGroup.add(myTimerGroup);

    // 2) Позиционируем группу по верхней границе рамки
    const frameInnerHeight = (frameGroup.userData && typeof frameGroup.userData.innerH === 'number')
      ? frameGroup.userData.innerH
      : defaultInnerH;

    // Поднимаем таймер к верхней части (половина высоты)
    const topEdgePosition = new THREE.Vector3(0, frameInnerHeight / 2, 0);
    myTimerGroup.position.copy(topEdgePosition);

    // Слегка «выдвинем» таймер вперёд (по нормали рамки), чтобы не пересекаться
    const offsetDistance = 1;
    const forwardNormal = new THREE.Vector3(0, 0, 0);
    forwardNormal.applyQuaternion(frameGroup.quaternion);
    myTimerGroup.position.add(forwardNormal.multiplyScalar(offsetDistance));

    // 3) Загружаем SVG
    createSVGTimer('//www.hecticdecals.com.au/cdn/shop/t/4/assets/timer.svg?v=55454824555008025041739148932', (loadedSVG) => {
      if (!loadedSVG) return;
      // Теперь добавляем сам загруженный SVG внутрь группы
      myTimerGroup.add(loadedSVG);

      // Настраиваем поворот/масштаб:
      loadedSVG.rotation.y = -Math.PI * 2;
      loadedSVG.rotation.x = -Math.PI * 2;
      loadedSVG.rotation.z = -Math.PI / 1;
      loadedSVG.scale.set(0.0011, 0.0011, 0.0011);

      // Позиция внутри группы — (0,0,0).
      loadedSVG.position.set(0.20, 0.38, -0.1);
      const worldPos = new THREE.Vector3();
      loadedSVG.getWorldPosition(worldPos);
      console.log("Мировая позиция таймера:", worldPos);
      // Ставим пока "00:00:00:00"
      setTimerValue(loadedSVG, 0, 0, 0, 0);

      // 4) Обновляем каждую секунду
      const intervalId = setInterval(() => {
        const now = Date.now();
        let dist = endDate - now;
        if (dist <= 0) {
          // Таймер истёк
          clearInterval(intervalId);
          // Можно скрыть
          myTimerGroup.visible = false;
          return;
        }
        // Считаем D/H/M/S
        const d = Math.floor(dist / (1000 * 60 * 60 * 24));
        const h = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((dist % (1000 * 60)) / 1000);

        // Устанавливаем сегменты
        setTimerValue(loadedSVG, d, h, m, s);
      }, 1000);
    });
  } else {
    console.warn("Не удалось распарсить дату из тега:", countdownTag);
  }
} else {
  console.log("Нет тега вида 'countdown:YYYY/M/D-HH:MMAM/PM' в window.product.tags");
}

// --------------------------------------------------------------------------------------
// 13) Основной цикл анимации
// --------------------------------------------------------------------------------------
function animate() {
  requestAnimationFrame(animate);
  const dt = clock.getDelta();
  const elapsed = clock.getElapsedTime();

  // Линейная интерполяция позиции камеры
  const lerpFactor = 0.05;
  camera.position.lerp(targetCameraPosition, lerpFactor);

  if (activeNavButton && activeNavButton.userData.targetTextPanel) {
    let panelCenter = new THREE.Vector3();
    activeNavButton.userData.targetTextPanel.getWorldPosition(panelCenter);
    camera.lookAt(panelCenter);
  } else {
    camera.lookAt(targetLookAt);
  }

  // Анимации «стеклянных цилиндров»
  glassCylinderGroups.forEach((group) => {
    group.updateBubbles();
    group.updateFlicker();
  });

  // Hover-эффект для рамки
  if (ringMesh && ringMesh.userData.edgeMaterial) {
    const frameRaycaster = new THREE.Raycaster();
    frameRaycaster.setFromCamera(cursor, camera);
    const frameIntersections = frameRaycaster.intersectObject(ringMesh, true);
    const frameHovered = frameIntersections.length > 0;
    if (frameHovered) {
      ringMesh.userData.edgeMaterial.color.lerp(new THREE.Color(0xffa500), 0.1);
    } else {
      ringMesh.userData.edgeMaterial.color.lerp(new THREE.Color(0x9700ff), 0.1);
    }
  }

  // Движущиеся «гексы»
  const mouseNDC = new THREE.Vector3(cursor.x, cursor.y, 0.5);
  mouseNDC.unproject(camera);
  const rayDir = mouseNDC.sub(camera.position).normalize();
  const ray = new THREE.Ray(camera.position, rayDir);
  const focusPlane = new THREE.Plane(new THREE.Vector3(1, 0, 0), -1);
  const hexTarget = new THREE.Vector3();
  ray.intersectPlane(focusPlane, hexTarget);
  const focalYZ = new THREE.Vector2(hexTarget.y, hexTarget.z);

  const baseAmp = -0.05;
  const maxAmp = -0.15;
  const thresholdDist = 0.5;
  const waveFactor = 5.0;
  const colorTransitionThreshold = 0.5;

  const minColor = new THREE.Color(0xff7e00);
  const midColor = new THREE.Color(0xeb00ff);
  const maxColor = new THREE.Color(0x9900ff);

  for (let hx of movingHexes) {
    if (hx.ampFactor === 0) {
      hx.mesh.position.x = baseAmp;
      hx.edgeMaterial.color.copy(minColor);
      continue;
    }
    const worldPos = new THREE.Vector3();
    hx.mesh.getWorldPosition(worldPos);
    const hexPosYZ = new THREE.Vector2(worldPos.y, worldPos.z);
    const distance = hexPosYZ.distanceTo(focalYZ);

    let osc = (Math.sin(elapsed - waveFactor * hexPosYZ.length() + hx.phase) + 1) / 2;
    let scale = 1;
    if (distance < thresholdDist) {
      scale = 1 + (1 - distance / thresholdDist);
    }
    let effectiveAmp = baseAmp + (maxAmp - baseAmp) * osc * scale;
    const absBase = Math.abs(baseAmp);
    const absMax = Math.abs(maxAmp);
    let absEff = Math.abs(effectiveAmp);
    absEff = THREE.MathUtils.clamp(absEff, absBase, absMax);
    effectiveAmp = effectiveAmp < 0 ? -absEff : absEff;
    hx.mesh.position.x = effectiveAmp;

    const normalizedAmp = (Math.abs(effectiveAmp) - absBase) / (absMax - absBase);
    let newColor;
    if (normalizedAmp <= colorTransitionThreshold) {
      const t = normalizedAmp / colorTransitionThreshold;
      newColor = minColor.clone().lerp(midColor, t);
    } else {
      const t = (normalizedAmp - colorTransitionThreshold) / (1 - colorTransitionThreshold);
      newColor = midColor.clone().lerp(maxColor, t);
    }
    hx.edgeMaterial.color.copy(newColor);
  }

  // Hover навигационных кнопок
  navRaycaster.setFromCamera(cursor, camera);
  const navIntersections2 = navRaycaster.intersectObjects(navButtonsGroup.children, true);
  navButtonsGroup.children.forEach((button) => {
    let hovered = navIntersections2.some((intersection) => {
      let obj = intersection.object;
      while (obj && !obj.userData.screenId && typeof obj.userData.updateHover !== "function") {
        obj = obj.parent;
      }
      return obj === button;
    });
    if (button.userData.updateHover) {
      button.userData.updateHover(hovered);
    }
    if (
      button.userData.updateIdle &&
      (!button.userData.clickTimeline || !button.userData.clickTimeline.isActive()) &&
      !button.userData.isHovered &&
      !button.userData.glowingPlane
    ) {
      button.userData.updateIdle(dt, elapsed);
    }
  });

  // Hover текстовых панелей
  textPanelRaycaster.setFromCamera(cursor, camera);
  const textPanelIntersections = textPanelRaycaster.intersectObjects([leftPanel, rightPanel], true);
  hoveredTextPanel = textPanelIntersections.length > 0 ? textPanelIntersections[0].object : null;
  [leftPanel, rightPanel].forEach((panel) => {
    if (panel === hoveredTextPanel) {
      panel.userData.edgeMaterial.color.set(0xffff00);
    } else {
      panel.userData.edgeMaterial.color.set(0x9700ff);
    }
    // Поворачиваем панель "к камере"
    panel.lookAt(camera.position);
  });

  // Кнопка покупки
  purchaseButton.update(dt, elapsed, camera, cursor);

  // Название продукта
  productTitle.update(dt, camera, cursor);

  // Кнопка полноэкранного режима
  fullscreenButton.update(dt, elapsed, camera, cursor);

  // Кнопки соцсетей
  if (socialLinks) {
    socialLinks.update(dt, elapsed, camera, cursor);
  }
  // Обновляем позицию соц. иконок (если нужно подстраиваться под размер рамки)
  {
    const innerH = (frameGroup.userData && typeof frameGroup.userData.innerH === 'number')
      ? frameGroup.userData.innerH
      : defaultInnerH;
    const basePos = new THREE.Vector3(0, -innerH / 2, 0);
    const normal = new THREE.Vector3(-1, -0.4, 0);
    normal.applyQuaternion(frameGroup.quaternion);
    const extrudeOffset = normal.multiplyScalar(0.1);
    const updatedPosition = new THREE.Vector3().copy(basePos).add(extrudeOffset);
    socialLinks.object3D.position.copy(updatedPosition);
  }
  // Финальный рендер
  renderer.render(scene, camera);
}

animate();
